$(document).ready(function(){
  $('#newsletter-form').on('submit', function(e){
  	e.preventDefault();
    var target = e.target;
    
    var form = new FormData();
    form.append("email", target.contact.value);
    form.append("status", "active");
    form.append("listid", "69558");

    var settings = {
      "url": "https://api.vbout.com/1/emailmarketing/addcontact?key=6011282251376156126486105",
      "method": "POST",
      "timeout": 0,
      "processData": false,
      "mimeType": "multipart/form-data",
      "contentType": false,
      "data": form
    };

    var putReq = $.ajax(settings);
    
    putReq.done(function(){
      target.contact.value = '';
      $('#newsletter-form').prepend("<div class='note note--success' id='newsletterSuccess'>Successfully added to Newsletter!</div>")
    });
    
  });
  
  $('#newsletterModalForm').on('submit', function(e){
  	e.preventDefault();
    var target = e.target;
    
    var form = new FormData();
    form.append("email", target.contact.value);
    form.append("status", "active");
    form.append("listid", "69558");

    var settings = {
      "url": "https://api.vbout.com/1/emailmarketing/addcontact?key=6011282251376156126486105",
      "method": "POST",
      "timeout": 0,
      "processData": false,
      "mimeType": "multipart/form-data",
      "contentType": false,
      "data": form
    };

    var putReq = $.ajax(settings);
    
    putReq.done(function(){
      target.contact.value = '';
      $('#newsletterModalForm').prepend("<div class='note note--success' id='newsletterSuccess'>Successfully added to Newsletter!</div>")
    });
    
  });
});